import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=f3cec3d2&"
import script from "./Completion.vue?vue&type=script&lang=js&"
export * from "./Completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3cec3d2')) {
      api.createRecord('f3cec3d2', component.options)
    } else {
      api.reload('f3cec3d2', component.options)
    }
    module.hot.accept("./Completion.vue?vue&type=template&id=f3cec3d2&", function () {
      api.rerender('f3cec3d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/QuestionItem/Completion.vue"
export default component.exports